import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
// import { showFastAddDialog } from '../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(
						showAddNotesDialog({ model: { note_table: 'erp_orders', note_table_uid: model.ords_uid } })
					)
			}
			// {
			// 	name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
			// 	icon: 'history',
			// 	iconAdd: true,
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'chronology',
			// 				updateRefresh,
			// 				model: {
			// 					chro_maac_uid: model.oppo_maac_uid,
			// 					maac_title: model.maac_title,
			// 					chro_oppo_uid: model.oppo_uid,
			// 					oppo_title: model.oppo_title,
			// 					chro_comp_uid: model.oppo_comp_uid,
			// 					comp_title: model.comp_title,
			// 					chro_peop_uid: model.oppo_peop_uid,
			// 					peop_title: model.peop_title
			// 				}
			// 			})
			// 		)
			// },
			// {
			// 	name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
			// 	icon: 'puzzle-outline',
			// 	iconAdd: true,
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'activities',
			// 				updateRefresh,
			// 				model: {
			// 					acti_maac_uid: model.oppo_maac_uid,
			// 					maac_title: model.maac_title,
			// 					acti_oppo_uid: model.oppo_uid,
			// 					oppo_title: model.oppo_title,
			// 					acti_comp_uid: model.oppo_comp_uid,
			// 					comp_title: model.comp_title,
			// 					acti_peop_uid: model.oppo_peop_uid,
			// 					peop_title: model.peop_title
			// 				}
			// 			})
			// 		)
			// }
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// }
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// }
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			}
		],
		fabs: [
			// {
			// 	id: 'details',
			// 	name: 'ACTION_EDIT',
			// 	icon: 'edit-outline',
			// 	action: ({ switchEdit }) => switchEdit()
			// }
			// {
			// 	id: 'chronology',
			// 	name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
			// 	icon: 'history',
			// 	iconAdd: true,
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'chronology',
			// 				updateRefresh,
			// 				model: {
			// 					chro_maac_uid: model.oppo_maac_uid,
			// 					maac_title: model.maac_title,
			// 					chro_oppo_uid: model.oppo_uid,
			// 					oppo_title: model.oppo_title,
			// 					chro_comp_uid: model.oppo_comp_uid,
			// 					comp_title: model.comp_title,
			// 					chro_peop_uid: model.oppo_peop_uid,
			// 					peop_title: model.peop_title
			// 				}
			// 			})
			// 		)
			// },
			// {
			// 	id: 'activities',
			// 	name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
			// 	icon: 'puzzle-outline',
			// 	iconAdd: true,
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'activities',
			// 				updateRefresh,
			// 				model: {
			// 					acti_maac_uid: model.oppo_maac_uid,
			// 					maac_title: model.maac_title,
			// 					acti_oppo_uid: model.oppo_uid,
			// 					oppo_title: model.oppo_title,
			// 					acti_comp_uid: model.oppo_comp_uid,
			// 					comp_title: model.comp_title,
			// 					acti_peop_uid: model.oppo_peop_uid,
			// 					peop_title: model.peop_title
			// 				}
			// 			})
			// 		)
			// }
		]
	}
};

export default buttons;
